module.exports = __webpack_public_path__ + "de89a75a7085423ed43f6a3892ef868b.svg";